(()=>{
if(window.np3Loaded)return;
window.np3Loaded=true;
document.addEventListener('click',e=>{
const t=e.target.closest('[data-np3-thumb]');
if(!t)return;
const g=t.closest('[data-np3-gallery]');
if(!g)return;
const i=t.getAttribute('data-np3-thumb');
g.querySelectorAll('[data-np3-slide]').forEach(s=>{
const on=s.getAttribute('data-np3-slide')===i;
s.classList.toggle('is-active',on);
if(!on)s.querySelectorAll('video').forEach(v=>v.pause());
});
g.querySelectorAll('[data-np3-thumb]').forEach(b=>{
const on=b===t;
b.classList.toggle('is-active',on);
b.setAttribute('aria-pressed',on?'true':'false');
});
});
const fmt=(n,c)=>{try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:c,maximumFractionDigits:0}).format(n)}catch(_){return String(Math.round(n))}};
const num=el=>el?parseFloat(el.value)||0:0;
const calc=r=>{
const q=s=>r.querySelector(s);
const price=num(q('[data-np3-machine]'));
const weekly=Math.max(0,(num(q('[data-np3-charge]'))-num(q('[data-np3-cost]')))*num(q('[data-np3-sets]')));
const c=r.getAttribute('data-np3-currency')||'CAD';
const has=weekly>0;
q('[data-np3-weekly]').textContent=has?fmt(weekly,c):'—';
q('[data-np3-monthly]').textContent=has?fmt(weekly*52/12,c):'—';
const p=q('[data-np3-payback]');
p.textContent=has&&price>0?Math.ceil(price/weekly)+' '+(p.getAttribute('data-unit')||'weeks'):'—';
};
const init=root=>root.querySelectorAll('[data-np3-calc]').forEach(r=>{
if(r.dataset.np3Ready)return;
r.dataset.np3Ready='1';
r.addEventListener('input',()=>calc(r));
r.addEventListener('change',()=>calc(r));
calc(r);
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
document.addEventListener('shopify:section:load',e=>init(e.target));
})();
